import React from 'react'
import { Tabs, Tab, Box } from '@mui/material'
import { ReportsActionType, useReportsContext } from '../ReportsContext'
import CustomTooltip from '../../../components/CustomTooltip'

const tabOptions = [
  { label: 'Current Term', value: 1 },
  { label: 'Last Term', value: 2 },
  { label: '3 Terms', value: 3 },
  { label: '5 Terms', value: 5 },
  { label: '10 Terms', value: 10 },
  { label: 'ALL', value: 40 }
]

const TABS_DISABLED_TOOLTIP = 'Tabs are disabled because display settings have changed. Please reset your changes.'

const TermsTabs: React.FC = () => {
  const { selectedTrend, displaySettingsChanged, dispatch } = useReportsContext()

  const tabsContent = (
    <Tabs
      value={selectedTrend}
      onChange={(_, newValue) => {
        dispatch({ type: ReportsActionType.SET_SELECTED_TREND, payload: newValue })
      }}
      aria-label="category-tabs"
      variant="scrollable"
      scrollButtons="auto"
      allowScrollButtonsMobile
      sx={{
        '& .MuiTab-root': {
          fontSize: '16px',
          fontWeight: 600
        },
        ...(displaySettingsChanged && {
          opacity: 0.6
        })
      }}
    >
      {tabOptions.map((tab) => (
        <Tab key={tab.value} label={tab.label} value={tab.value} disabled={displaySettingsChanged} />
      ))}
    </Tabs>
  )

  return (
    <Box sx={{ mb: 3, borderBottom: 1, borderColor: 'divider' }}>
      {displaySettingsChanged
        ? (
        <CustomTooltip title={TABS_DISABLED_TOOLTIP}>
          <span style={{ display: 'block' }}>{tabsContent}</span>
        </CustomTooltip>
          )
        : (
            tabsContent
          )}
    </Box>
  )
}

export default TermsTabs
